// @flow
import {deleteCreator, getCreator, postCreator} from '../../http';
import environment from '../../environment';
import {putCreator} from '../../http/index';

export type ProcessorParameters = {
  culqi?: {
    phone: string,
    sourceId: string,
  },
  payu?: {},
  stripe?: {},
  name: string,
};

export type SubscribeRequest = {
  automaticCharge: boolean,
  storeTierPlanId?: string,
  coupon?: string,
  currency: string,
  paymentData: {
    payWithCard: boolean,
    billingAddress?: {
      firstName: string,
      lastName: string,
      idNumber: string,
      address1: string,
      country: string,
      admin1?: string,
      admin2?: string,
      admin3?: string,
    },
    paymentProviderId?: string,
    processorParameters?: ProcessorParameters,
    userCardProfileId?: string,
    savePaymentInformation?: boolean,
  },
};

export type SubscribeUpdateRequest = {
  automaticCharge?: boolean,
  storeTierPlanId?: string,
  coupon?: string,
  currency?: string,
  paymentData?: {
    payWithCard: boolean,
    billingAddress?: {
      firstName: string,
      lastName: string,
      idNumber: string,
      address1: string,
      country: string,
      admin1?: string,
      admin2?: string,
      admin3?: string,
    },
    paymentProviderId?: string,
    processorParameters?: ProcessorParameters,
    userCardProfileId?: string,
    savePaymentInformation?: boolean,
  },
};

export type SaveCardRequest = {
  paymentProviderId?: string,
  billingAddress?: {
    firstName: string,
    lastName: string,
    idNumber: string,
    address1: string,
    country: string,
    admin1?: string,
    admin2?: string,
    admin3?: string,
  },
};

export type PurchaseSummaryRequest = {
  storeTierPlanId: string,
  currency: string,
  coupon?: string,
};

export const endpoints = Object.freeze({
  FETCH_PAYMENT_PROVIDERS: `${environment.baseApiUrl}/checkout/admin/processing/payment-provider`,
  DELETE_CARD_PROFILE: `${environment.baseApiUrl}/checkout/admin/user-card-profile/:id`,
  FETCH_CARD_PROFILE: `${environment.baseApiUrl}/checkout/admin/user-card-profile/:id`,
  FETCH_CARD_PROFILES: `${environment.baseApiUrl}/checkout/admin/user-card-profile`,
  PURCHASE_SUMMARY: `${environment.baseApiUrl}/checkout/admin/subscription/purchase-summary`,
  SUBSCRIBE: `${environment.baseApiUrl}/checkout/admin/subscription/subscribe`,
  PAYU_INITIALIZE: `${environment.baseApiUrl}/checkout/admin/subscription/initialize/payu-web`,
  // FREE_TRIAL_SUBSCRIBE: `${environment.baseApiUrl}/checkout/admin/subscription/subscribe/free-trial`  // This is the old endpoint,
  FREE_TRIAL_SUBSCRIBE: `${environment.baseApiUrl}/pluto/subscription/stripe/free-trial`,

  STRIPE_INITIALIZE: `${environment.baseApiUrl}/checkout/admin/subscription/initialize/stripe`,
  STRIPE_ADD_CARD_INITIALIZE: `${environment.baseApiUrl}/checkout/admin/user-card-profile/initialize/stripe`,
  STRIPE_CARD_STATE: `${environment.baseApiUrl}/checkout/admin/user-card-profile/:id/status`,
  SET_CURRENT_CARD: `${environment.baseApiUrl}/checkout/admin/user-card-profile/:id/set-current`,
});

export const getPaymentProvidersApi = getCreator(
  endpoints.FETCH_PAYMENT_PROVIDERS
);
export const deleteCardApi = deleteCreator(endpoints.DELETE_CARD_PROFILE);
export const fetchCardApi = getCreator(endpoints.FETCH_CARD_PROFILE);
export const fetchCardsApi = getCreator(endpoints.FETCH_CARD_PROFILES);
export const fetchPurchaseSummaryApi = postCreator(endpoints.PURCHASE_SUMMARY);
export const performSubscribeApi = postCreator(endpoints.SUBSCRIBE);
export const payUInitializeApi = postCreator(endpoints.PAYU_INITIALIZE);
export const freeTrialSubscribeApi = postCreator(
  endpoints.FREE_TRIAL_SUBSCRIBE
);
export const stripeInitializeApi = postCreator(endpoints.STRIPE_INITIALIZE);
export const stripeUpdateApi = putCreator(endpoints.STRIPE_INITIALIZE);
export const stripeAddCardInitializeApi = postCreator(
  endpoints.STRIPE_ADD_CARD_INITIALIZE
);
export const fetchCardStateApi = getCreator(endpoints.STRIPE_CARD_STATE);
export const setCurrentCardApi = postCreator(endpoints.SET_CURRENT_CARD);
